import { VideoCall } from '../../../types/chat.types';
import {
  ChatState,
  ChatStateWithOptionalId,
} from '../hooks/useChats/reducer/chatListReducer.types';

export type ChatContextState = {
  view: ChatView;
  hasErrorInConnectionToWs: boolean;
  minimizedChatIds: string[];
  activeChat?: ChatState | ChatStateWithOptionalId;
};

export type ChatActions =
  | { type: 'UPDATE_SELECTED_CHAT'; payload?: UpdateSelectedChatPayload }
  | { type: 'OPEN_CHAT_CREATION' }
  | { type: 'OPEN_GROUP_CHAT_CREATION' }
  | { type: 'OPEN_GROUPED_ROOMS' }
  | { type: 'CLOSE_ACTIVE_CHAT' }
  | { type: 'DELETE_VIDEO_CALL' }
  | { type: 'MINIMIZE_ACTIVE_CHAT' }
  | { type: 'REMOVE_CHAT_FROM_MINIMIZED'; payload: RemoveChatFromMinimizedPayload }
  | { type: 'OPEN_PRIVATE_CHAT'; payload: OpenPrivateChatPayload }
  | { type: 'ERROR_CONNECTING_TO_WS' }
  | { type: 'OPEN_ROOMS_OF_GROUP'; payload: OpenRoomsOfGroupPayload }
  | { type: 'ADD_VIDEO_CALL_IN_ACTIVE_CHAT'; payload: AddVideoCallInActiveChatPayload }
  | {
      type: 'RESET_STATE';
    };

export enum ChatViewType {
  GroupCreation = 'group-creation',
  PrivateCreation = 'private-creation',
  GroupedRooms = 'grouped-rooms',
  RoomsOfGroup = 'rooms-of-group',
}

type CreationChatView = {
  type: ChatViewType.GroupCreation;
};

type PrivateCreationChatView = {
  type: ChatViewType.PrivateCreation;
};

export type RoomsOfGroupChatView = {
  type: ChatViewType.RoomsOfGroup;
  groupMetaId: string;
};

type GroupedRoomsChatView = {
  type: ChatViewType.GroupedRooms;
};

export type ChatView =
  | PrivateCreationChatView
  | CreationChatView
  | RoomsOfGroupChatView
  | GroupedRoomsChatView;

export const isRoomsOfGroupChatView = (view: ChatView): view is RoomsOfGroupChatView => {
  return view.type === ChatViewType.RoomsOfGroup;
};

export const isOnGroupedRooms = (view: ChatView): view is GroupedRoomsChatView => {
  return view.type === ChatViewType.GroupedRooms;
};

export interface UpdateSelectedChatPayload {
  chat?: ChatState;
  minimizeCurrentActiveChat?: boolean;
}

export interface OpenPrivateChatPayload {
  chat: ChatStateWithOptionalId;
}

export interface OpenRoomsOfGroupPayload {
  groupMetaId: string;
}

export interface RemoveChatFromMinimizedPayload {
  chatId: string;
}

export interface AddVideoCallInActiveChatPayload {
  videoCall: VideoCall;
}
